import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useMemo,
  useState,
} from 'react'
import { SanityModule } from '@data/sanity/queries/types/modules'
import { getFilteredPageModules } from './module'

interface PageModuleContextProps {
  pageModules: SanityModule[]
  casePageModules?: SanityModule[]
  previewPageModules?: SanityModule[]
  setCasePageModules: Dispatch<SetStateAction<SanityModule[] | undefined>>
  setPreviewPageModules: Dispatch<SetStateAction<SanityModule[] | undefined>>
}

interface PageModuleContextProviderProps {
  modules?: SanityModule[] | null
  children: ReactNode
}

export const PageModuleContext = createContext<PageModuleContextProps>({
  pageModules: [],
  setCasePageModules: () => {},
  setPreviewPageModules: () => {},
})

export const PageModuleContextProvider = ({
  modules,
  children,
}: PageModuleContextProviderProps) => {
  const [casePageModules, setCasePageModules] = useState<SanityModule[]>()
  const [previewPageModules, setPreviewPageModules] = useState<SanityModule[]>()

  const pageModules = useMemo(() => {
    return getFilteredPageModules(modules ?? [])
  }, [modules])

  return (
    <PageModuleContext.Provider
      value={{
        pageModules,
        casePageModules,
        previewPageModules,
        setCasePageModules,
        setPreviewPageModules,
      }}
    >
      {children}
    </PageModuleContext.Provider>
  )
}
